import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsOptional, IsString } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
import { ReadAbstractItemMetadataPosDto } from './ReadAbstractItemMetadataPosDto';
export class ReadItemOptionsMetadataPosDto extends ReadAbstractItemMetadataPosDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, example: '0000000591300000' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemOptionsMetadataPosDto.prototype, "pos_id", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'https://www.toasttab.com/restaurants/admin/menus/menu?id=1234512313131313' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemOptionsMetadataPosDto.prototype, "pos_url", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: '0000002897570004' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemOptionsMetadataPosDto.prototype, "pos_number", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemOptionsMetadataPosDto.prototype, "pos_isItemBaseParent", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadItemOptionsMetadataPosDto.prototype, "posSync", void 0);
//# sourceMappingURL=ReadItemOptionsMetadataPosDto.js.map